export const CARD_DATA = [
  {
    heading: "German Language Training",
    name: "Mr. Keyur Soni",
    details: "From A1 to B1/B2 level.",
  },

  {
    heading: "Exam Preparation",
    name: "Mr. Keyur Soni",
    details: "Ensure success with personalized study plans.",
  },

  {
    heading: "Profile Evaluation",
    name: "Mr. Keyur Soni",
    details:
      "Align your strengths with the right Ausbildung program.",
  },

  {
    heading: "Document Verification",
    name: "Mr. Keyur Soni",
    details: "Ensure accuracy and completeness for your applications.",
  },
  {
    heading: "Vocational Training Application",
    name: "Mr. Keyur Soni",
    details: "Assistance in applying to trusted Ausbildung programs.",
  },


  {
    heading: "Admission/Offer Letter Support",
    name: "Mr. Keyur Soni",
    details: "Help secure your place at vocational schools and companies.",
  },
  {
    heading: "Accommodation Assistance",
    name: "Mr. Keyur Soni",
    details: "Guidance on finding	 suitable housing in Germany.",
  },
  {
    heading: "Visa Assistance",
    name: "Mr. Keyur Soni",
    details: "Step-by-step support for smooth visa processing.",
  },
];
